import Page from './Page.vue';

export default Page;
